import React from 'react';
import styles from './Toggle.module.css';
import { classNames } from '../../utils/helpers';

function Toggle({
  checked = false,
  onChange,
  label,
  description,
  disabled = false,
  className,
  ...props
}) {
  return (
    <label className={classNames(styles.container, disabled && styles.disabled, className)}>
      <div className={styles.content}>
        {label && <span className={styles.label}>{label}</span>}
        {description && <span className={styles.description}>{description}</span>}
      </div>
      <div className={styles.toggleWrapper}>
        <input
          type="checkbox"
          className={styles.input}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <div className={classNames(styles.toggle, checked && styles.checked)}>
          <div className={styles.thumb} />
        </div>
      </div>
    </label>
  );
}

export default Toggle;
